import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { getGrowProjectBadgeDetails, getGroupedInvestments, GrowProject } from '@inyova/grow';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inyova-grow-project-preview',
  templateUrl: './inyova-grow-project-preview.component.html',
  styleUrls: ['./inyova-grow-project-preview.component.scss'],
  standalone: false
})
export class InyovaGrowProjectPreviewComponent implements OnInit, OnChanges {
  @Input() project: GrowProject;
  badge: { type: string; key: string };
  language: string;

  constructor(private translateService: TranslateService) {
    this.language = this.translateService.currentLang;
  }

  ngOnInit() {
    this.badge = getGrowProjectBadgeDetails(getGroupedInvestments(this.project.investments)[0].status);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.project && !changes.project.firstChange) {
      this.badge = getGrowProjectBadgeDetails(getGroupedInvestments(this.project.investments)[0].status);
    }
  }
}
